import { render, staticRenderFns } from "./detailsContent.vue?vue&type=template&id=dbcaa408&scoped=true"
import script from "./detailsContent.vue?vue&type=script&lang=js"
export * from "./detailsContent.vue?vue&type=script&lang=js"
import style0 from "./detailsContent.vue?vue&type=style&index=0&id=dbcaa408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcaa408",
  null
  
)

export default component.exports